import { render, staticRenderFns } from "./FlixcheckIntegrationSettings.vue?vue&type=template&id=7f4a61c0"
import script from "./FlixcheckIntegrationSettings.vue?vue&type=script&lang=ts"
export * from "./FlixcheckIntegrationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports